export const NavHeight = 64;
export const NavMobileHeight = 72;
export const SecondaryNavHeight = 64;
export const NavFullMinimizedHeight = NavHeight + SecondaryNavHeight;

export const spaceValues = {
  xs: '20rem',
  sm: '24rem',
  md: '28rem',
  lg: '32rem',
  xl: '36rem',
  '2xl': '42rem',
  '3xl': '48rem',
  '4xl': '56rem',
  '5xl': '64rem',
  '6xl': '72rem',
  '7xl': '80rem',
  navMobileHeight: `${NavMobileHeight}px`,
  navHeight: `${NavHeight}px`,
  navSecondaryHeight: `${SecondaryNavHeight}px`,
  navFullMinimizedHeight: `${NavFullMinimizedHeight}px`,
};
